// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7683b59","816":"6e0a3bc8"}[chunkId] + ".chunk.js";
};